// used by partial club_records/_form_fields
;(function () {
  window.initClubRecordFieldToggles = function (el) {
    var awarded_toggle, form, resigned_toggle
    form = $(el)
    awarded_toggle = form.find(".is_awarded input")
    awarded_toggle.on("change", function () {
      var awarded, rows_only_when_awarded, rows_only_when_not_awarded
      awarded = $(this).is(":checked")
      rows_only_when_not_awarded = form.find(
        ".field.renonciert_at, .field.recipiert_at, .field.philistriert_at"
      )
      rows_only_when_awarded = form.find(".field.awarded_at")
      if (awarded) {
        rows_only_when_not_awarded.addClass("hidden")
        return rows_only_when_awarded.removeClass("hidden")
      } else {
        rows_only_when_not_awarded.removeClass("hidden")
        return rows_only_when_awarded.addClass("hidden")
      }
    })
    awarded_toggle.trigger("change")
    resigned_toggle = form.find(".is_resigned input")
    resigned_toggle.on("change", function () {
      var resigned
      resigned = $(this).is(":checked")
      return form
        .find(".field.resigned_reason, .field.resigned_at")
        .toggleClass("hidden", !resigned)
    })
    return resigned_toggle.trigger("change")
  }
}).call(this)
